// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"153":"0a2a514c","490":"82013b46","644":"3ea85f3c","753":"b7f9d377","765":"4d372bda","951":"f3aff1ef"}[chunkId] + ".chunk.js";
};